import { Button } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { buttonLightGrey, darkgrey } from 'styles/Colors';

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 60px;
  bottom: 0px;
  left: 0px;
  background: white;
`;

export const StyledFooterContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0px 20px 0px 20px;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    background-color: ${buttonLightGrey};
    color: ${darkgrey};
  }
` as typeof Button;

export const RightSide = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
`;
